var _rect, _rect2, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 40,
    viewBox: "0 0 94 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 39,
    rx: 19.5,
    stroke: "#DB4335"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2103_7801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2103_7801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.2499V12.75L32.7114 19.9999L15.5 27.2499ZM17 24.9999L28.85 19.9999L17 14.9999V18.6923L22.423 19.9999L17 21.3076V24.9999Z",
    fill: "#DB4225"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.656 22.912H43.16C43.464 24.24 44.376 24.96 45.976 24.96C47.72 24.96 48.408 24.144 48.408 23.104C48.408 21.984 47.864 21.36 45.624 20.816C43 20.176 42.088 19.28 42.088 17.712C42.088 16.064 43.32 14.72 45.8 14.72C48.456 14.72 49.544 16.256 49.688 17.712H48.184C47.992 16.72 47.368 15.904 45.752 15.904C44.392 15.904 43.624 16.512 43.624 17.584C43.624 18.624 44.264 19.04 46.2 19.504C49.384 20.288 49.944 21.52 49.944 22.944C49.944 24.736 48.616 26.144 45.896 26.144C43.096 26.144 41.88 24.624 41.656 22.912ZM51.8559 14.256H53.2639V19.088C53.6799 18.384 54.4159 17.696 55.7919 17.696C57.0879 17.696 58.5279 18.416 58.5279 20.832V26H57.1359V21.056C57.1359 19.68 56.5439 18.912 55.3759 18.912C53.9039 18.912 53.2639 19.888 53.2639 21.568V26H51.8559V14.256ZM66.8726 20.368V24.24C66.8726 24.976 66.9366 25.776 66.9846 26H65.6406C65.5766 25.824 65.5286 25.44 65.5126 24.944C65.2246 25.488 64.5846 26.192 63.0166 26.192C61.0966 26.192 60.2806 24.96 60.2806 23.728C60.2806 21.904 61.7046 21.088 64.1206 21.088C64.6806 21.088 65.1926 21.088 65.4966 21.088V20.384C65.4966 19.68 65.2726 18.8 63.7526 18.8C62.3926 18.8 62.1686 19.472 62.0246 20.112H60.6646C60.7766 18.992 61.4646 17.696 63.8006 17.696C65.7846 17.712 66.8726 18.512 66.8726 20.368ZM65.5126 22.32V22.048C65.2406 22.048 64.6326 22.048 64.2006 22.048C62.5686 22.048 61.7046 22.496 61.7046 23.648C61.7046 24.48 62.2966 25.104 63.2886 25.104C65.2406 25.104 65.5126 23.792 65.5126 22.32ZM69.2934 26V20.096C69.2934 18.96 69.2934 18.32 69.2774 17.888H70.6534C70.6854 18.128 70.7014 18.752 70.7014 19.552C71.1174 18.448 72.0934 17.744 73.4374 17.696V19.104C71.7734 19.152 70.7014 20.016 70.7014 22.064V26H69.2934ZM81.3534 22.208H75.6414C75.6414 23.856 76.4734 25.024 77.8494 25.024C79.1454 25.024 79.5614 24.368 79.8174 23.776H81.2254C80.9054 24.816 80.0414 26.192 77.8174 26.192C75.2574 26.192 74.2174 24.128 74.2174 22.032C74.2174 19.632 75.4334 17.696 77.8974 17.696C80.5214 17.696 81.3854 19.808 81.3854 21.536C81.3854 21.776 81.3854 21.984 81.3534 22.208ZM75.6894 21.216H79.9614C79.9454 19.888 79.2734 18.816 77.8814 18.816C76.4574 18.816 75.8334 19.808 75.6894 21.216Z",
    fill: "#DB4225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareClicked);
export default __webpack_public_path__ + "static/media/ShareClicked.7d6f3d496a9ba68f86385110d310910b.svg";
export { ForwardRef as ReactComponent };